'use client';
import rte, { rteToPlainText } from '@/utils/rte';

const PriceDetailsModal = ({ priceDetails }) => {
  const modalContent = rteToPlainText(priceDetails)
    ? priceDetails
    : '';

  if (!modalContent) {
    return null;
  }

  return (
    <div className='px-6 p-16 lg:p-24'>
        <div
          dangerouslySetInnerHTML={{
            __html: rte(modalContent),
          }}
        />
    </div>
  );
};

export default PriceDetailsModal;
